import { M024CopyPrevDTO, M024CreationOptionsDTO, M024ResponseOptionsDTO, M024UpdateOptionsDTO } from "./dto";
import { M024ServiceImpl } from "./serviceImpl";

export interface M024Service {
    /* ASSIGNMENT */
    CreateM024(data: M024CreationOptionsDTO): Promise<M024ResponseOptionsDTO>
    M024CopyPrev(data: M024CopyPrevDTO): Promise<void>
    Updatem024Options(data: M024UpdateOptionsDTO, id: string): Promise<void>
    DeleteM024(id: string): Promise<void>
}

export function NewM024Service(): M024Service {
    return new M024ServiceImpl()
}